import { loadedLibrary } from 'actions/global';

import { getApartmentById } from 'actions/apartment';

import { withAsyncEnterLoader, withLoader } from 'util/routeHelper';
import { loadGoogleMapLibrary } from 'util/script';

export default store => ({
	path: 'apartment',
	indexRoute: {
		component: null,
		onEnter: ({ params: { lang } }, replace) => replace(`/${lang}/404`),
	},
	childRoutes: [
		{
			path: ':id',
			getComponent: withLoader(
				(nextState, cb) =>
					require.ensure(
						[],
						require => {
							const component = require('./component').default;
							cb(null, component);
						},
						'Apartment',
					),
				store,
				'APARTMENT',
			),
			onEnter: withAsyncEnterLoader(
				async ({ params: { id } }, __, updateRatio) => {
					updateRatio(0.3);

					await store.dispatch(getApartmentById(id));
					updateRatio(0.5);

					await loadGoogleMapLibrary();
					store.dispatch(loadedLibrary('googleMap'));

					updateRatio(0.8);
				},
				store,
				'ENTER_APARTMENT',
			),
		},
	],
});



// WEBPACK FOOTER //
// ./src/routes/Apartment/index.js